import React, {FC} from "react";

export const SectionDivider: FC<{}> = () => {
  return <hr className={'border-slate-100 my-8'} />
}